import { useI18n } from "../i18n";

const labels = {
  READY:"ready", REVIEW:"review", MISSING:"missing", AWAITING_RESPONSE:"awaitingResponse",
  NOT_SCHEDULED:"notScheduled", NOT_ATTENDING:"notAttending"
} as const;

export function StatusBadge({ status }: { status: string }) {
  const { t } = useI18n();
  const key = labels[status as keyof typeof labels];
  return <span className={`status-badge status-${status.toLowerCase().replaceAll("_","-")}`}><i />{key ? t(key) : status.replaceAll("_"," ")}</span>;
}
